import { Auth } from '@aws-amplify/auth';
import { GetHLSStreamingSessionURLCommand, HLSPlaybackMode, KinesisVideoArchivedMediaClient, } from '@aws-sdk/client-kinesis-video-archived-media';
import { isNonNaNNumber, Milliseconds } from '@iotv/iotv-v3-types';
import { Environment } from 'internal-config';
import { useContext, useEffect } from 'react';
import { KinesisVideoStreamContext } from '../Context/KinesisVideoStreamContext';
const { region, stage, projectCode } = Environment;
// 2026 09 11 option to use CloudFront distribution for HLS streaming URLs. If false use KVS directly
const useCloudFront = false;
const cloudfrontDistributionUrl = `https://video.${stage}.${projectCode.substring(0, 4)}.iotv.link`;
const getCloudFrontUrl = ({ kvsEndpoint, url }) => {
    return url.replace(kvsEndpoint, cloudfrontDistributionUrl);
};
export const useHLSFragments = ({}) => {
    const { state, dispatch } = useContext(KinesisVideoStreamContext);
    const { kvaClient, selectedStreamInfo, DataEndpoint, HLSStreamingSessionURL, selectedHLSPlaybackMode, selectedHLSFragmentSelectorType, fromTimestamp, toTimestamp, } = state;
    const PlaybackMode = selectedHLSPlaybackMode;
    const TimestampRange = PlaybackMode === HLSPlaybackMode.LIVE || !fromTimestamp || !toTimestamp
        ? undefined
        : {
            StartTimestamp: new Date(fromTimestamp),
            EndTimestamp: new Date(toTimestamp),
        };
    const DisplayFragmentTimestamp = 'ALWAYS';
    const FragmentSelectorType = selectedHLSFragmentSelectorType;
    const ContainerFormat = 'FRAGMENTED_MP4';
    const DiscontinuityMode = 'ALWAYS';
    const MaxMediaPlaylistFragmentResults = selectedHLSPlaybackMode === HLSPlaybackMode.LIVE ? 5 : 500;
    const setKVAClient = async () => {
        console.log(`destroying KVA Client`);
        state.kvaClient?.destroy();
        console.log(`Setting KVA Client`);
        const credentials = await Auth.currentUserCredentials();
        const kvaClient = new KinesisVideoArchivedMediaClient({ region, credentials });
        dispatch({ kvaClient });
    };
    const getStreamUrl = async (retry = 0) => {
        if (kvaClient && selectedStreamInfo) {
            console.log(`getting stream`, selectedStreamInfo);
            try {
                const params = {
                    // StreamName: selectedStreamInfo.StreamName, << only 1 of
                    StreamARN: selectedStreamInfo.StreamARN,
                    PlaybackMode: selectedHLSPlaybackMode,
                    DisplayFragmentTimestamp,
                    ContainerFormat,
                    DiscontinuityMode,
                    MaxMediaPlaylistFragmentResults,
                };
                if (selectedHLSPlaybackMode !== HLSPlaybackMode.LIVE) {
                    console.log(`getting stream with timestamp range`, TimestampRange);
                    params.HLSFragmentSelector = {
                        FragmentSelectorType,
                        TimestampRange,
                    };
                }
                else {
                    console.log(`getting stream with no timestamp range`);
                }
                const { HLSStreamingSessionURL, $metadata } = await kvaClient.send(new GetHLSStreamingSessionURLCommand(params));
                console.log(`getStream url: ${HLSStreamingSessionURL}, from ${TimestampRange?.StartTimestamp} to ${TimestampRange?.EndTimestamp}`);
                const HLSListFragmentsURL = useCloudFront && DataEndpoint && HLSStreamingSessionURL ? getCloudFrontUrl({ kvsEndpoint: DataEndpoint, url: HLSStreamingSessionURL }) : HLSStreamingSessionURL;
                dispatch({ HLSStreamingSessionURL, DataEndpoint, HLSListFragmentsURL, fetchVideoStreamError: null });
            }
            catch (e) {
                console.error(`getStreamUrl err, ${e.message}`);
                if (e.message === 'The security token included in the request is expired') {
                    if (retry < 2) {
                        console.error(`Trying to resolve error ${e.message} with last retry ${retry}`);
                        setKVAClient().then(() => {
                            setTimeout(() => {
                                getStreamUrl(retry + 1);
                            }, Milliseconds.SECOND);
                        });
                    }
                    else {
                        console.error(`Giving up trying to resolve error ${e.message} as retries is ${retry}`);
                        dispatch({ HLSStreamingSessionURL: null, HLSListFragmentsURL: null, fetchVideoStreamError: e.message });
                    }
                }
                else {
                    dispatch({ HLSStreamingSessionURL: null, HLSListFragmentsURL: null, fetchVideoStreamError: e.message });
                }
            }
        }
    };
    useEffect(() => {
        if (kvaClient) {
            console.log(`KVA Client ready: ${selectedHLSPlaybackMode} ${selectedHLSFragmentSelectorType} ${isNonNaNNumber(fromTimestamp) && isNonNaNNumber(toTimestamp) ? `from ${new Date(fromTimestamp).toString()} to ${new Date(toTimestamp).toString()}` : ''}. Consumer must call getStreamUrl() to fetch the stream url.`);
        }
        else {
            console.log(`KVA Client not ready, cannot fetch stream url`);
        }
    }, [kvaClient, selectedHLSFragmentSelectorType, selectedHLSPlaybackMode, fromTimestamp, toTimestamp]);
    return { getStreamUrl };
};
